/** Maps HTTP errors to live error codes — mirrors mobile live_exceptions.dart */

export function parseLiveError(err) {
  const status = err?.response?.status
  const data = err?.response?.data
  const message = typeof data?.message === 'string' ? data.message : ''
  const code = data?.code

  if (status === 400) {
    if (message.toLowerCase().includes('just ended')) return 'LIVE_JUST_ENDED'
    return 'INVALID_STATE'
  }
  if (status === 403) {
    if (code === 'LIVE_BANNED' || message.toLowerCase().includes('banned')) return 'BANNED'
    if (code === 'LIVE_PRIVACY' || /private|friends|close friends/i.test(message)) return 'PRIVACY'
    if (message.toLowerCase().includes('muted')) return 'MUTED'
    return 'FORBIDDEN'
  }
  if (status === 404) return 'NOT_FOUND'
  if (status === 409) {
    if (message.toLowerCase().includes('already reported')) return 'ALREADY_REPORTED'
    return 'ALREADY_ACTIVE'
  }
  if (status === 429) return 'RATE_LIMIT'
  if (!err?.response) return 'NETWORK_ERROR'
  return 'UNKNOWN'
}

export function isLivePrivacyError(err) {
  return parseLiveError(err) === 'PRIVACY'
}

export function isLiveBannedError(err) {
  return parseLiveError(err) === 'BANNED'
}
